import React from "react";
import AreaQualifierClassList from './area-qualifier-class-list';
const AreaQualifierClassView = ({
  classes
}) => {
  return <AreaQualifierClassList classes={classes} data-sentry-element="AreaQualifierClassList" data-sentry-component="AreaQualifierClassView" data-sentry-source-file="area-qualifier-class-view.jsx" />;
};
export default AreaQualifierClassView;